import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/webp/paypal.webp';
import _imports_1 from '@/assets/img/webp/mastercard.webp';
import _imports_2 from '@/assets/img/webp/visa.webp';
import _imports_3 from '@/assets/img/webp/american-express.webp';
import _imports_4 from '@/assets/img/webp/dhl.webp';
import _imports_5 from '@/assets/img/webp/ems.webp';
import _imports_6 from '@/assets/img/webp/fed-ex.webp';
import _imports_7 from '@/assets/img/webp/ups.webp';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5be9c75b"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "footer-list"
};
var _hoisted_2 = {
  "class": "item"
};
var _hoisted_3 = {
  "class": "title"
};
var _hoisted_4 = {
  "class": "btns"
};
var _hoisted_5 = {
  "class": "item"
};
var _hoisted_6 = {
  "class": "title"
};
var _hoisted_7 = {
  "class": "item-list"
};
var _hoisted_8 = {
  "class": "link",
  href: "https://www.facebook.com/ai.chiplink.limited"
};
var _hoisted_9 = {
  "class": "link",
  href: "https://www.linkedin.com/company/ai-chiplink-limited/"
};
var _hoisted_10 = {
  "class": "link",
  href: "https://www.instagram.com/aichiplink_official/"
};
var _hoisted_11 = {
  "class": "link",
  href: "https://twitter.com/aichiplink"
};
var _hoisted_12 = {
  "class": "item"
};
var _hoisted_13 = {
  "class": "title"
};
var _hoisted_14 = {
  "class": "item-list"
};
var _hoisted_15 = {
  "class": "item"
};
var _hoisted_16 = {
  "class": "title"
};
var _hoisted_17 = {
  "class": "item-list"
};
var _hoisted_18 = {
  "class": "item"
};
var _hoisted_19 = {
  "class": "title"
};
var _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"item-list\" data-v-5be9c75b><div class=\"icon\" data-v-5be9c75b><img src=\"" + _imports_0 + "\" alt=\"paypal logo\" data-v-5be9c75b></div><div class=\"icon\" data-v-5be9c75b><img src=\"" + _imports_1 + "\" alt=\"visa logo\" data-v-5be9c75b></div><div class=\"icon\" data-v-5be9c75b><img src=\"" + _imports_2 + "\" alt=\"visa logo\" data-v-5be9c75b></div><div class=\"icon\" data-v-5be9c75b><img src=\"" + _imports_3 + "\" alt=\"american express logo\" data-v-5be9c75b></div></div>", 1);
var _hoisted_21 = {
  "class": "item"
};
var _hoisted_22 = {
  "class": "title"
};
var _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"item-list\" data-v-5be9c75b><div class=\"icon\" data-v-5be9c75b><img src=\"" + _imports_4 + "\" alt=\"dhl logo\" data-v-5be9c75b></div><div class=\"icon\" data-v-5be9c75b><img src=\"" + _imports_5 + "\" alt=\"ems logo\" data-v-5be9c75b></div><div class=\"icon\" data-v-5be9c75b><img src=\"" + _imports_6 + "\" alt=\"fedex logo\" data-v-5be9c75b></div><div class=\"icon\" data-v-5be9c75b><img src=\"" + _imports_7 + "\" alt=\"ups logo\" data-v-5be9c75b></div></div>", 1);
import { inject } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'footer',
  setup: function setup(__props) {
    var formatTime = inject("formatTime");
    var toEmail = function toEmail() {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "footer_email"
        });
      }
    };
    var toWhatsapp = function toWhatsapp() {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "sidebar_whatsapp"
        });
      }
    };
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Contact Us")), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
        target: "_blank",
        onClick: toEmail,
        href: "mailto:info@aichiplink.com",
        "class": "btn"
      }, "Email Us: info@aichiplink.com"), _createVNode(_component_router_link, {
        "class": "btn",
        to: {
          name: 'contact-us'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Feedback")), 1)];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("Follow Us")), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("FaceBook")), 1), _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t("LinkedIn")), 1), _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t("Ins")), 1), _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t("Twitter")), 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("Company")), 1), _createElementVNode("div", _hoisted_14, [_createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'about-us'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("About Us")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'contact-us'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Contact Us")), 1)];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("Resources")), 1), _createElementVNode("div", _hoisted_17, [_createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'category'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Categories")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'manufacturer'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Manufacturer")), 1)];
        }),
        _: 1
      }), _createVNode(_component_router_link, {
        "class": "link",
        to: {
          name: 'rfq'
        }
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("Request a Quote")), 1)];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("Payment")), 1), _hoisted_20]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("Shipping")), 1), _hoisted_23])]);
    };
  }
});